declare global {
	interface Window {
		dataLayer: Record<string, unknown>[];
	}
}

const sendGtmEvent = (eventData: Record<string, unknown>) => {
	if (window.dataLayer) {
		window.dataLayer.push(eventData);
	}
};

export default sendGtmEvent;
